import { SHOW_HELP, HIDE_HELP } from "./types";

export const showHelp = (screen) => {
  return {
    type: SHOW_HELP,
    payload: screen,
  };
};

export const hideHelp = () => {
  return {
    type: HIDE_HELP,
  };
};
